import {NewDeliveryPoint} from "../../domain/dtos/new-delivery-point";
import {DeliveryAddressMapper} from "@app/core/delivery-point/infrastructure/mappers/delivery-address.mapper";

export class NewDeliveryPointMapper {

    static serialize(param: NewDeliveryPoint): any {
        return {
            name: param.businessName,
            tax_id: param.cif,
            trade_name: param.commercialName,
            telephone: param.phoneNumber,
            shipping_address: DeliveryAddressMapper.serialize(param.deliveryAddress),
            billing_address: DeliveryAddressMapper.serialize(param.deliveryAddress)
        };
    }
}
